import { t } from '@lingui/core/macro';
import { NoddiIcon } from 'noddi-ui-common';
import { NoddiBasicCard } from 'noddi-ui-web';
import { useAuthContext } from 'noddi-web';
import { useState } from 'react';
import { CustomerLoginModal } from './CustomerLoginModal';

/**
 * Login offered on the booking flow's first step, so a returning customer picks a saved address and car
 * instead of typing them again. The step re-renders with the saved addresses once logged in.
 */
export const AddressStepLogin = () => {
  const { isLoggedIn } = useAuthContext();
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);

  if (isLoggedIn) {
    return null;
  }

  return (
    <>
      <NoddiBasicCard
        className='mt-3 flex items-center justify-between gap-3 px-4 py-3'
        onClick={() => setIsLoginModalOpen(true)}
      >
        <div className='flex items-center gap-3'>
          <NoddiIcon name='User' size='small' className='shrink-0' />
          <div className='flex flex-col'>
            <p className='text-sm font-semibold'>{t`Customer already?`}</p>
            {/* The step sits on a tinted brand background, where the muted token all but vanishes. */}
            <p className='text-sm text-foreground/70'>{t`Log in to use your saved addresses and cars`}</p>
          </div>
        </div>
        <NoddiIcon name='ChevronRight' size='xSmall' className='shrink-0' />
      </NoddiBasicCard>
      <CustomerLoginModal
        open={isLoginModalOpen}
        onClose={() => setIsLoginModalOpen(false)}
        description={t`Log in with your mobile number to use your saved addresses and cars.`}
      />
    </>
  );
};
